import React, {useState, useEffect} from 'react'
import {ImageView} from '../../components/meImage/ImageView'
import {meSplitter} from '../../components/Shared/meLayout'
import TreeView from "../../components/meTree/TreeView"
import TableView from '../../components/meTable/TableView'
import {ToNotify} from 'fast_inon'
import {Read} from '../../components/Shared/Api'
import Header from '../Header';

const Digitization = ({lang, account, search}) => {
  const app = 'Digitization'
  const container = 'HomeContainer'
  const [message, Message] = useState('')
  const [cell, Cell] = useState({entity:'', id:0, field:'', value:''})
  const [node, Node] = useState({entity:'', id:0, parent:0})
  const [clip, Clip] = useState({entity:'Clip', id:0})
  const [detail, Detail] = useState('')
  

  const [layouts, Layouts]= useState([])
  const [colors, Colors]= useState([])

  const splitter = new meSplitter("Side", container)

  useEffect(()=>{
    //Read(`/Layout/Colors`,Colors,null,null)

    Read(`/Layout/${container}`,Layouts,null,null)
  },[])

  useEffect(()=>{
    splitter.InitStyle(layouts)
  },[layouts])

  const onNode = (item) => {
    //alert(`entity=${item.entity}, id=${item.id}`)
    Detail(`/data/${item.entity}/${item.id}`) //;alert(`TableView ${url}`)
    Node(item)
  }

  const onCell = (item) => {
    //console.log(cell)
    Cell(item)
  }

  useEffect(()=>{
    if(node.entity==='Page'){
      Clip({...clip, id:node.id})
    }
    else {
      Clip({...clip, id:0})
    }

  },[node])

        return (

  account.connected ?
<>
<Header lang={lang} service={app} account={account} />
<div className="Sides" id={container}
  onMouseDown={(e)=>{splitter.mouseDown(e)}} 
  onMouseMove={(e)=>{splitter.mouseMove(e)}} 
  onMouseUp={(e)=>{splitter.mouseUp(e)}}
>

  <div className="side vside" id="SideTimer" style={{width: '25%'}}>
    <TreeView app={app} request={'service/Nodes/'+app} lang={lang} onChange={onNode} Message={Message} />
  </div>
  
  <div className="side vside" id="SideImage" style={{width: '40%'}}>
    {
    node.entity==='Page' ?
      <ImageView node={node} onNode={onNode} Message={Message} />
    : 
      <TableView node={node} onChange={onCell} onNode={onNode} Message={Message} request={detail} />
    }
  </div>

  <div className="side vside" id="SideDetail" style={{width: '35%'}}>
  { clip.id>0 ?
    <TableView node={clip} onChange={onCell} onNode={onNode} Message={Message} />
  : <h3>Detail</h3> }
  </div>

  <ToNotify 
    message={message}
    onClose={()=>{Message('')}}
  />

</div>
</>  
: <div className="Sides">LogIn</div>    
        )
    
}

export {Digitization}